import { formats } from "@/utils/formats";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { NoData } from "./NoData";
import { CommonFieldProps } from "./types";

type DateFieldProps = CommonFieldProps & { showTime?: boolean };

export const DateField = ({
  name,
  data,
  getValue,
  showTime = false,
}: DateFieldProps) => {
  const { i18n } = useTranslation();

  const value = data[name];

  return value ? (
    <Typography>
      {format(
        getValue ? getValue(data) : new Date(value),
        showTime
          ? formats.dateTimeFormats[i18n.language]
          : formats.dateFormats[i18n.language]
      )}
    </Typography>
  ) : (
    <NoData />
  );
};
